export const Loading = () => {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#F9F6F0]">
      <svg 
        className="animate-spin h-32 w-32 text-[#2D4220]" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24"
      >
        <path 
          className="opacity-75" 
          fill="currentColor" 
          d="M12 1.5c.267 0 .533.014.798.04l-.714 2.983a5.54 5.54 0 00-.168-.003 5.53 5.53 0 105.53 5.53c0-.057-.001-.113-.003-.17l2.983-.713c.026.265.04.531.04.798 0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8zm0 4a4 4 0 100 8 4 4 0 000-8z"
        />
      </svg>
    </div>
  );
};